import { render, staticRenderFns } from "./ThgQuoteDetailImageCard.vue?vue&type=template&id=57a4df67&"
import script from "./ThgQuoteDetailImageCard.vue?vue&type=script&lang=ts&"
export * from "./ThgQuoteDetailImageCard.vue?vue&type=script&lang=ts&"
import style0 from "./ThgQuoteDetailImageCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
